import React from 'react';
import PropTypes from 'prop-types';

import InfiniteTable from '../../../../../common/InfiniteTable/InfiniteTable';
import ParticipantListItem from '../../../ParticipantListItem.container';
import NoResults from '../../../NoResults';
import {
  ContentStyle,
  ListSeparator,
  Container,
  SearchResultContainer,
  Loader,
  LoadingContainer,
} from './UserSearchResultsList.styled';
import { User } from '../types';

const UserSearchResultsList = (props) => {
  const { users, isFetching, searchQuery, onSelectUser } = props;
  if (!searchQuery.trim()) {
    return null;
  }

  if (isFetching) {
    return (
      <LoadingContainer>
        <Loader />
      </LoadingContainer>
    );
  }

  const renderUser = (user) => {
    const { id, firstName, lastName, email, avatar, educatorInSpaces } = user;

    return (
      <>
        <Container onClick={onSelectUser(user)}>
          <ParticipantListItem
            userId={id}
            fullName={`${firstName} ${lastName}`}
            email={email}
            avatar={avatar}
            showActionButtons={false}
            educatorInSpaces={educatorInSpaces}
          />
        </Container>
        <ListSeparator />
      </>
    );
  };

  return (
    <InfiniteTable
      contentStyle={ContentStyle}
      viewProps={{ 'data-testid': 'self-serve-user-search-result' }}
      renderHeader={() => (
        <SearchResultContainer>{`${users.length} results for ${searchQuery}`}</SearchResultContainer>
      )}
      items={users}
      keyExtractor={({ id }) => id}
      renderItem={renderUser}
      renderEmptyList={() => (
        <NoResults
          primaryText="Your search didn’t match any user in your institution."
          secondaryText=" Make sure the spelling is correct or try a different search."
        />
      )}
    />
  );
};

UserSearchResultsList.propTypes = {
  users: PropTypes.arrayOf(User),
  isFetching: PropTypes.bool.isRequired,
  onSelectUser: PropTypes.func.isRequired,
  searchQuery: PropTypes.string,
};

UserSearchResultsList.defaultProps = {
  users: [],
  searchQuery: '',
};

export default UserSearchResultsList;
